import { IEditCategoria } from "interfaces/eventos";

const categoriaDefault: IEditCategoria[] = [
  {
    id: 1,
    descricao: "15 a 24 anos",
    qtdMinima: 1,
    idadeInicial: 15,
    idadefinal: 24,
    tagId: 1,
    sexoId: 2,
  },
  {
    id: 2,
    descricao: "25 a 29 anos",
    qtdMinima: 1,
    idadeInicial: 25,
    idadefinal: 29,
    tagId: 1,
    sexoId: 2,
  },
  {
    id: 3,
    descricao: "30 a 34 anos",
    qtdMinima: 1,
    idadeInicial: 30,
    idadefinal: 34,
    tagId: 1,
    sexoId: 2,
  },
  {
    id: 4,
    descricao: "35 a 39 anos",
    qtdMinima: 1,
    idadeInicial: 35,
    idadefinal: 39,
    tagId: 1,
    sexoId: 2,
  },
  {
    id: 5,
    descricao: "40 a 44 anos",
    qtdMinima: 1,
    idadeInicial: 40,
    idadefinal: 44,
    tagId: 1,
    sexoId: 2,
  },
  {
    id: 6,
    descricao: "45 a 49 anos",
    qtdMinima: 1,
    idadeInicial: 45,
    idadefinal: 49,
    tagId: 1,
    sexoId: 2,
  },
  {
    id: 7,
    descricao: "50 a 54 anos",
    qtdMinima: 1,
    idadeInicial: 50,
    idadefinal: 54,
    tagId: 1,
    sexoId: 2,
  },
  {
    id: 8,
    descricao: "55 a 59 anos",
    qtdMinima: 1,
    idadeInicial: 55,
    idadefinal: 59,
    tagId: 1,
    sexoId: 2,
  },
  {
    id: 9,
    descricao: "60 a 64 anos",
    qtdMinima: 1,
    idadeInicial: 60,
    idadefinal: 64,
    tagId: 2,
    sexoId: 2,
  },
  {
    id: 10,
    descricao: "65 anos acima",
    qtdMinima: 1,
    idadeInicial: 65,
    idadefinal: 99,
    tagId: 2,
    sexoId: 2,
  },
  {
    id: 11,
    descricao: "15 a 29 anos",
    qtdMinima: 1,
    idadeInicial: 15,
    idadefinal: 29,
    tagId: 1,
    sexoId: 3,
  },
  {
    id: 12,
    descricao: "30 a 34 anos",
    qtdMinima: 1,
    idadeInicial: 30,
    idadefinal: 34,
    tagId: 1,
    sexoId: 3,
  },
  {
    id: 13,
    descricao: "35 a 39 anos",
    qtdMinima: 1,
    idadeInicial: 35,
    idadefinal: 39,
    tagId: 1,
    sexoId: 3,
  },
  {
    id: 14,
    descricao: "40 a 44 anos",
    qtdMinima: 1,
    idadeInicial: 40,
    idadefinal: 44,
    tagId: 1,
    sexoId: 3,
  },
  {
    id: 15,
    descricao: "45 a 49 anos",
    qtdMinima: 1,
    idadeInicial: 45,
    idadefinal: 49,
    tagId: 1,
    sexoId: 3,
  },
  {
    id: 16,
    descricao: "50 a 54 anos",
    qtdMinima: 1,
    idadeInicial: 50,
    idadefinal: 54,
    tagId: 1,
    sexoId: 3,
  },
  {
    id: 17,
    descricao: "55 a 59 anos",
    qtdMinima: 1,
    idadeInicial: 55,
    idadefinal: 59,
    tagId: 1,
    sexoId: 3,
  },
  {
    id: 18,
    descricao: "60 a 99 anos",
    qtdMinima: 1,
    idadeInicial: 60,
    idadefinal: 99,
    tagId: 2,
    sexoId: 3,
  },
];

export default categoriaDefault;
